import {
  PRODUCTCOMPLAIN_LOADING,
  GET_PRODUCTCOMPLAIN,
  GET_PRODUCTCOMPLAIN_SUCCESS,
  GET_PRODUCTCOMPLAIN_FAIL,
  ADD_PRODUCTCOMPLAIN_SUCCESS,
  ADD_PRODUCTCOMPLAIN_FAIL,
  DELETE_PRODUCTCOMPLAIN_SUCCESS,
  DELETE_PRODUCTCOMPLAIN_FAIL,
  UPDATE_PRODUCTCOMPLAIN_SUCCESS,
  UPDATE_PRODUCTCOMPLAIN_FAIL,
  PRODUCTCOMPLAIN_RESET
} from "./actionType";

const INIT_STATE = {
  productComplains: [],
  error: {},
};

const ProductComplain = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTCOMPLAIN_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTCOMPLAIN:
          return {
            ...state,
            productComplains: action.payload.data,
            isProductComplainCreated: false,
            isProductComplainUpdate: false,
            isProductComplainSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTCOMPLAIN_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTCOMPLAIN_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductComplainCreated: false,
            isProductComplainUpdate: false,
            isProductComplainSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTCOMPLAIN: {
      return {
        ...state,
        isProductComplainCreated: false,
        isProductComplainUpdate: false,
        loading: true,
      };
    }

    case PRODUCTCOMPLAIN_LOADING: {
      return {
        ...state,
        isProductComplainCreated: false,
        isProductComplainUpdate: false,
        loading: true,
      };
    }

    case ADD_PRODUCTCOMPLAIN_SUCCESS:
      return {
        ...state,
        isProductComplainCreated: true,
        loading: false,
        productComplains: [action.payload.data, ...state.productComplains],
      };

    case ADD_PRODUCTCOMPLAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTCOMPLAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductComplainCreated: true,
        productComplains: state.productComplains.filter(
          productComplain => productComplain.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTCOMPLAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTCOMPLAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductComplainCreated: true,
        isProductComplainUpdate: true,
        productComplains: state.productComplains.map(productComplain =>
          productComplain.id.toString() === action.payload.data.id.toString() ? { ...productComplain, ...action.payload.data } : productComplain
        ),
      };

    case UPDATE_PRODUCTCOMPLAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTCOMPLAIN_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductComplain;